import { ICreateHabilidadeUseCase } from "../../../presentation/useCases/create/create_habilidade_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateHabilidadeUseCase
 */

export class CreateHabilidadeUseCase implements ICreateHabilidadeUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createHabilidade(
    descricao: string,
    habilidade: string,
  ): Promise<void> {
    await this.repository.createHabilidade(
      habilidade,
      descricao,
    )
  }
}
